import http from "../../http-common";

class EuroAnonymousFormSubmitService {
    postEuroAnonymousFormSubmitService(formBody: {}) {
        return http.get(`/anonymous-form-submit//euro-convergence`, formBody);
    }
}

export default new EuroAnonymousFormSubmitService();
